import React from "react";
import Cryptocurrencies from "../components/Cryptocurrencies";

const CryptocurrenciesPage = () => {
  return (
    <div>
      <Cryptocurrencies />
    </div>
  );
};

export default CryptocurrenciesPage;
